(function() {
  // Function to initialize all modals on the page
  function initializeModals() {
    const offerBanners = document.querySelectorAll('.js-offer-banner');

    offerBanners.forEach((banner, index) => {
      // Try to find modal within the banner first (original structure)
      let modal = banner.querySelector('.productGrid__bmsmModal');
      
      // If not found within banner, look for the next modal after the banner (new structure)
      if (!modal) {
        let currentElement = banner.nextElementSibling;
        // Keep looking through siblings until we find a modal or run out of elements
        while (currentElement) {
          if (currentElement.classList.contains('productGrid__bmsmModal') || 
              currentElement.classList.contains('js-offer-tooltip')) {
            modal = currentElement;
            break;
          }
          currentElement = currentElement.nextElementSibling;
        }
      }
      
      if (!modal) return;

      const modalId = `offer-tooltip-${index}`;
      modal.id = modalId;

      // Find all toggle buttons within this specific banner
      const toggleButtons = banner.querySelectorAll('.js-tooltip-toggle');
      toggleButtons.forEach(button => {
        button.setAttribute('aria-controls', modalId);
        button.setAttribute('aria-expanded', 'false');
      });
      
      // Also set aria-controls on close buttons within the modal (for new structure)
      const closeButtons = modal.querySelectorAll('.js-tooltip-toggle');
      closeButtons.forEach(button => {
        button.setAttribute('aria-controls', modalId);
        button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Function to get the associated banner for a modal
  function getBannerForModal(modal) {
    // First try to find banner as parent (original structure)
    let banner = modal.closest('.js-offer-banner');
    
    // If not found, look backwards through previous siblings (new structure)
    if (!banner) {
      let currentElement = modal.previousElementSibling;
      while (currentElement) {
        if (currentElement.classList.contains('js-offer-banner')) {
          banner = currentElement;
          break;
        }
        currentElement = currentElement.previousElementSibling;
      }
    }
    
    return banner;
  }

  // Function to get the associated modal background for a modal
  function getModalBgForModal(modal) {
    // First try to find within the same parent (original structure)
    const banner = getBannerForModal(modal);
    let modalBg = banner?.querySelector('.productGrid__bmsmModalBg');
    
    // If not found within banner, look for next sibling after modal (new structure)
    if (!modalBg) {
      let currentElement = modal.nextElementSibling;
      while (currentElement) {
        if (currentElement.classList.contains('productGrid__bmsmModalBg')) {
          modalBg = currentElement;
          break;
        }
        currentElement = currentElement.nextElementSibling;
      }
    }
    
    return modalBg;
  }

  // Function to close all open modals
  function closeAllModals() {
    document.querySelectorAll('.productGrid__bmsmModal.is--active, .js-offer-tooltip.is--active').forEach(modal => {
      modal.classList.remove('is--active');
      const modalId = modal.id;
      const banner = getBannerForModal(modal);

      // Remove show-banner class from the banner
      if (banner) {
        banner.classList.remove('show-banner');
      }

      // Deactivate the background if it exists
      const modalBg = getModalBgForModal(modal);
      if (modalBg) {
        modalBg.classList.remove('is--active');
      }

      // Update aria-expanded on all associated toggle buttons
      document.querySelectorAll(`[aria-controls="${modalId}"]`).forEach(button => {
        button.setAttribute('aria-expanded', 'false');
      });
    });
    
    // Remove class from body to re-enable scrolling (this is safe to run every time)
    document.body.classList.remove('overflow-hidden');
  }

  // --- SINGLE EVENT LISTENER FOR ALL CLICKS ---
  document.addEventListener('click', function(event) {
    const toggleButton = event.target.closest('.js-tooltip-toggle');

    // Case 1: A toggle button was clicked (to open or close)
    if (toggleButton) {
      event.preventDefault();
      
      // Check if this is a modal background click (which should close)
      if (toggleButton.classList.contains('productGrid__bmsmModalBg')) {
        closeAllModals();
        return;
      }
      
      const modalId = toggleButton.getAttribute('aria-controls');
      let modal = document.getElementById(modalId);

      // If we can't find by ID, try to find the modal associated with this banner
      if (!modal) {
        const banner = toggleButton.closest('.js-offer-banner');
        if (banner) {
          // Look within banner first
          modal = banner.querySelector('.productGrid__bmsmModal, .js-offer-tooltip');
          
          // If not found, look after banner
          if (!modal) {
            let currentElement = banner.nextElementSibling;
            while (currentElement) {
              if (currentElement.classList.contains('productGrid__bmsmModal') || 
                  currentElement.classList.contains('js-offer-tooltip')) {
                modal = currentElement;
                break;
              }
              currentElement = currentElement.nextElementSibling;
            }
          }
        }
      }

      if (modal) {
        const isExpanded = modal.classList.contains('is--active');
        const banner = getBannerForModal(modal);
        const modalBg = getModalBgForModal(modal);

        // Always close any open modals first
        closeAllModals();

        // If the clicked modal was not already open, then open it.
        if (!isExpanded) {
          modal.classList.add('is--active');
          
          // Add show-banner class to the banner
          if (banner) {
            if (window.matchMedia('(max-width: 1024px)').matches) {
              banner.classList.add('show-banner');
            }
          }
          
          if (modalBg) {
            modalBg.classList.add('is--active');
          }
          
          // Update aria on all related toggles
          if (modal.id) {
            document.querySelectorAll(`[aria-controls="${modal.id}"]`).forEach(button => {
              button.setAttribute('aria-expanded', 'true');
            });
          }
          
          // Conditionally add class to body to prevent scrolling only on smaller screens
          if (window.matchMedia('(max-width: 1024px)').matches) {
            document.body.classList.add('overflow-hidden');
          }
        }
      }
      return; // Stop further processing
    }

    // Case 2: The click was NOT on a toggle. Check if it was outside an active modal.
    // We need to check if the click was inside ANY modal content
    const clickedInsideModal = event.target.closest('.productGrid__bmsmModal, .js-offer-tooltip');
    if (!clickedInsideModal) {
      closeAllModals();
    }
  });

  // --- KEYDOWN LISTENER FOR ESCAPE KEY ---
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeAllModals();
    }
  });

  // --- INITIALIZE ON LOAD ---
  // Expose the function to the window object in case you need to call it after AJAX loads.
  window.initializeModals = initializeModals;
  document.addEventListener('DOMContentLoaded', initializeModals);

})();